import React from 'react';
import { styled } from '@linaria/react';

const LoadingLilButtons = ({
  isPoweredOn,
}: {
  isPoweredOn: boolean;
}) => {
  return (
    <Wrapper>
      <Svg
        width="24"
        height="17"
        viewBox="0 0 24 17"
        fill="none"
        style={{ opacity: isPoweredOn ? 1 : 0 }}
      >
        <Circle1 cx="7.5" cy="8.5" r="3.5" />
        <Circle2 cx="16.5" cy="8.5" r="3.5" />
      </Svg>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background: #2b2b2b;
  border-radius: 4px;
`;

const Svg = styled.svg`
  display: block;
  transition: opacity 300ms;
`;

const Circle = styled.circle`
  fill: #d90000;

  animation: glowing var(--duration) linear infinite both;
  animation-delay: var(--delay);

  @keyframes glowing {
    0% {
      opacity: 0;
    }

    60% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }
`;

const Circle1 = styled(Circle)`
  --duration: 2000ms;
  --delay: 0ms;
`;
const Circle2 = styled(Circle)`
  --duration: 1700ms;
  --delay: 1000ms;
`;

export default LoadingLilButtons;
